import { useMemo } from "react";
import {
    RecognitionMethod,
    ScheduleTermUnit,
} from "@common/types/domains/accounting/schedule";
import { Input } from "@design-system/Input/Input";
import { Picker } from "@design-system/Picker/Picker.lib";
import { buildTermUnitNounItems } from "../scheduleRecognitionUi";
import styles from "./ScheduleManualModal.module.scss";

export interface ScheduleRowTerm {
    length: number;
    unit: ScheduleTermUnit;
}

interface ScheduleTermControlsProps {
    term: ScheduleRowTerm;
    method: RecognitionMethod;
    portalContainer: HTMLElement | undefined;
    lengthAriaLabel?: string;
    lengthAriaLabelledBy?: string;
    unitAriaLabel?: string;
    onTermChange?: (term: ScheduleRowTerm) => void;
}

export const ScheduleTermControls = ({
    term,
    method,
    portalContainer,
    lengthAriaLabel,
    lengthAriaLabelledBy,
    unitAriaLabel,
    onTermChange,
}: ScheduleTermControlsProps) => {
    const unitItems = useMemo(() => {
        const items = buildTermUnitNounItems({ method });
        return onTermChange
            ? items
            : items.filter((item) => item.value === term.unit);
    }, [method, onTermChange, term.unit]);

    return (
        <>
            <Input
                className={styles.termLengthInput}
                type="number"
                min={1}
                size="md"
                aria-label={lengthAriaLabel}
                aria-labelledby={lengthAriaLabelledBy}
                readOnly={!onTermChange}
                tabIndex={onTermChange ? undefined : -1}
                value={term.length}
                onChange={(event) =>
                    onTermChange?.({
                        ...term,
                        length: Number(event.target.value),
                    })
                }
            />
            <Picker.Select
                items={unitItems}
                value={term.unit}
                onValueChange={(unit) => {
                    if (unit != null) {
                        onTermChange?.({ ...term, unit });
                    }
                }}
                container={portalContainer}
                trigger={
                    <Picker.Button
                        variant="primary"
                        size="md"
                        aria-label={unitAriaLabel}
                    />
                }
            />
        </>
    );
};
